import { observable, action, computed, observe, autorun } from 'mobx';
import FormStore from "./FormStore";
import api from "./api";
import _ from "lodash";
import {searchInObject} from "../utils/search";

class JobStore {
  constructor(api) {
    this.api = api;
    this.shipmentForm = new FormStore(this);

    // observe(this, "selectedJob", (change) => {
    //   if (change.newValue) {
    //     this.getShipments();
    //   }
    // });
    this.sampleShipment = {
      customer: {
        name: "",
        phone_number: "",
        email: ""
      },
      delivery_items: "",
      delivery_proof_photo_required: false,
      dropoff_address: {
        street: "",
        street2: "",
        city: "",
        state: "",
        zipcode: "",
      },
      dropoff_earliest_ts: "",
      dropoff_latest_ts: "",
      dropoff_note: "",
      pickup_address: {
        street: "",
        street2: "",
        city: "",
        state: "",
        zipcode: "",
      },
      pickup_note: "",
      signature_required: false,
      sms_enabled: false,
      value:"",
      currency:""
    };

    // Use autorun instead of observe to avoid decorator timing issues
    autorun(() => {
      if (this.selectedShipment) {
        this.shipmentForm.data = { ...this.sampleShipment, ...this.selectedShipment };
        this.getShipmentPOD();
      }

      this.processBoundary();
    });
  }

  REVIEW_STATUSES = ["GEOCODED", "GEOCODE_FAILED"];
  PROCESSING_STATUSES = ["CREATED", "GEOCODE_PREPARED", "GEOCODE_RESPONDED", "GEOCODE_PROCESSED"];
  PROGRESS_PERCENT_MAP = {
    "CREATED": 5,
    "GEOCODE_PREPARED": 10,
    "GEOCODE_RESPONDED": 90,
    "GEOCODE_PROCESSED": 95
  };
  PASSED = ['GEOCODED'];
  ERRORED = ['GEOCODE_FAILED', 'GEOCODE_FAILED_DROPOFF', 'GEOCODE_FAILED_PICKUP', 'UNSERVICEABLE'];

  @observable draftJobs = [];
  @observable finalizedJobs = [];
  @observable totalFinalizeJob;
  @observable selectedJob;
  @observable selectedShipment = null;
  @observable selectedJobShipments;
  @observable listCorrectedAddress = [];
  @observable loadingShipments = false;
  @observable deletingJob = false;
  @observable uploading = false;
  @observable finalizing = false;
  @observable updatingShipment = false;
  @observable deletingShipment = false;

  @observable shipmentFilter;
  @observable errorShipment = true;
  @observable okShipment = true;
  @observable duplicatedShipment = true;

  @observable page = 1;
  @observable size = 20;

  // map data
  @observable boundary;


  isProcessing(status) {
    return this.PROCESSING_STATUSES.includes(status);
  }

  isDraftJob(status) {
    return this.PROCESSING_STATUSES.includes(status) || this.REVIEW_STATUSES.includes(status);
  }

  getFinalizeQueryParams() {
    return {
      page: this.page - 1,
      size: this.size,
      order_by: "dropoff_earliest_ts",
      desc: true
    };
  }

  @action
  getFinalizeJobs(callback) {
    this.api.get('/jobs/finalize', this.getFinalizeQueryParams()).then(response => {
      if (response.status === 200) {
        this.finalizedJobs = response.data.items;
        this.totalFinalizeJob = response.data.count;
        if (callback) callback(response.data)
      }
    })
  }

  @action
  getDraftJobs(callback) {
    this.api.get('/jobs/draft').then(response => {
      if (response.status === 200) {
        this.draftJobs = response.data;
        if (callback) callback(response.data)
      }
    })
  }

  @action
  getFinalizeJob(jobId, callback) {
    this.api.get(`/jobs/finalize/${jobId}`).then(response => {
      if (response.status === 200) {
        // update job first
        if (callback) callback(response.data);
      }
    })
  }

  @action
  getDraftJob(jobId, callback) {
    this.api.get(`/jobs/draft/${jobId}`).then(response => {
      if (response.status === 200) {
        // update job first
        this.draftJobs = this.draftJobs.map(job => {
          if (job.id !== jobId) {
            return job;
          } else {
            const newJob = response.data;
            let percent = job.percent ? job.percent : this.PROGRESS_PERCENT_MAP[newJob.status];

            if (newJob.status === job.status) {
              percent += 2;
            }

            newJob.percent = percent;

            return newJob;
          }
        });

        if (callback) callback(response.data);
      }
    })
  }

  @action
  updateDraftShipment(callback, errorCb) {
    if (!this.selectedShipment || !this.selectedJob) return;
    this.updatingShipment = true;
    const data = this.shipmentForm.data;
    this.api.put(`/jobs/draft/${this.selectedJob.id}/shipments/${this.selectedShipment.id}`, data).then(response => {

      if (response.status === 200) {
        // process data here
        // get back job
        this.api.get(`/jobs/draft/${this.selectedJob.id}`).then(jobResp => {
          if (jobResp.status === 200) {
            // process shipment first
            const respShipment = response.data;
            const shipments = this.selectedJobShipments.map(s => {
              if (s.id !== respShipment.id) return s;
              else {
                this.selectedShipment = respShipment;
                return respShipment;
              }
            });

            // update job
            const respJob = jobResp.data;
            respJob.shipments = shipments;
            this.selectedJob = respJob;
            this.selectedJobShipments = shipments;

            this.updatingShipment = false;
            if (callback) callback(response.data, jobResp.data);
          }
        })
      } else {
          this.updatingShipment = false;
          if (errorCb) errorCb(response);
      }
    });
  }

  @action
  deleteDraftJob(jobId, callback) {
    this.deletingJob = true;
    this.api.delete(`/jobs/draft/${jobId}`).then(response => {
      this.deletingJob = false;
      if (response.status === 200) {
        this.draftJobs = this.draftJobs.filter(job => job.id !== response.data.id);
        this.selectedJob = null;
        if (callback) callback(response.data);
      }
    });
  }

  @action
  finalizeDraftJob(jobId, callback) {
    this.finalizing = true;
    this.api.post(`/jobs/draft/${jobId}/finalize`).then(response => {
      this.finalizing = false;
      if (response.status === 200) {
        this.finalizedJobs = [response.data].concat(this.finalizedJobs);
        this.draftJobs = this.draftJobs.filter(job => job.id !== jobId);
        this.selectedJob = null;
        this.selectedShipment = null;
        this.okShipment = true;
      }
      if (callback) callback(response);
    });
  }

  @action
  getShipments(callback) {
    if (this.selectedJob) {
      this.loadingShipments = true;
      const jobType = this.selectedJob.id.toString() === parseInt(this.selectedJob.id, 10).toString() ? 'finalize': 'draft';
      this.api.get(`/jobs/${jobType}/${this.selectedJob.id}/shipments`).then(response => {
        if (response.status === 200) {
          this.selectedJobShipments = 'finalize' === jobType ? response.data?.map(d => d.shipment) : response.data;
          this.listCorrectedAddress = response.data?.map(d => d.customerProfile);
          this.processBoundary();
          if (callback) callback(response.data);
        }
        this.loadingShipments = false;
      });
    }
  }

  @action
  getShipment(jobId, shipmentId) {
    const jobType = jobId.toString() === parseInt(jobId, 10).toString() ? 'finalize': 'draft';

    this.api.get(`/jobs/${jobType}/${jobId}/shipments/${shipmentId}`).then(response => {
      if (response.status === 200) {
        this.selectedShipment = response.data;
      }
    });
  }

  @action
  deleteDraftShipment(jobId, shipmentId, callback) {
    this.deletingShipment = true;
    this.api.delete(`/jobs/draft/${jobId}/shipments/${shipmentId}`).then(res => {
      if (res.ok) {
        const shipments = this.selectedJobShipments?.filter(sh => sh.id !== shipmentId);
        this.selectedJobShipments = shipments;
        this.selectedShipment = null;
        this.selectedJob.shipment_count -= 1;
        this.selectedJob.error_count = shipments?.filter(s => s.duplicate_fields || this.ERRORED.includes(s.status))?.length;
      }
      if (callback) callback(res);
      this.deletingShipment = false;
    })
  }

  @action
  getShipmentPOD() {
    if (!this.selectedShipment) return;
    // getting from api
    this.loadingShipmentPOD = true;
    const shipmentType = this.selectedShipment.id.toString() === parseInt(this.selectedShipment.id, 10).toString() ? 'finalize': 'draft';
    if (shipmentType === 'finalize') {
      api.get(`/shipments/${this.selectedShipment.id}/pod`)
        .then(response => {
          this.loadingShipmentPOD = false;
          if (!this.selectedShipment) return;
          this.selectedShipment.pod = response.data
        });
    }
  }

  upload(file, name, timezone, success, error) {
    const formData = new FormData();
    formData.append('csv', file);
    formData.append('name', name);
    formData.append('timezone', timezone);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };

    this.uploading = true;
    api.post(`/jobs/upload`, formData, config)
      .then(response => {
        this.uploading = false;
        // build job first
        if (response.status === 200) {
          if(response.data.job) {
            const job = response.data.job;
            job.shipments = response.data.shipments;
            this.draftJobs = [job].concat(this.draftJobs ? this.draftJobs: []);
            // ping to update status
            if (success) {
              success(job)
            }
          } else {
            if (success) {
              success(response, null)
            }
          }
        } else {
          if (error) error(response.data);
        }
      })
  }

  @computed
  get reviewJobs() {
    return this.draftJobs.filter(job => this.REVIEW_STATUSES.includes(job.status));
  }

  @computed
  get processingJobs() {
    return this.draftJobs.filter(job => this.PROCESSING_STATUSES.includes(job.status));
  }

  @computed
  get erroredShipments() {
    return (this.selectedJob && this.selectedJobShipments) ? this.selectedJobShipments.filter(job => this.ERRORED.includes(job.status)) : [];
  }

  @computed
  get passedShipments() {
    return (this.selectedJob && this.selectedJobShipments) ? this.selectedJobShipments.filter(job => this.PASSED.includes(job.status)) : [];
  }

  @computed
  get duplicatedShipments() {
    return (this.selectedJob && this.selectedJobShipments) ? this.selectedJobShipments.filter(job => job.duplicate_fields) : [];
  }

  // @computed
  // get selectedShipment() {
  //   if (!this.selectedJob || !this.selectedJobShipments || !this.selectedShipmentId) return null;
  //
  //   return this.selectedJobShipments.find(s => s.id.toString() === this.selectedShipmentId.toString());
  //   // console.log('s is: ', s);
  //   // return s;
  // }


  processBoundary() {
    if (!this.selectedJob || !this.selectedJobShipments || this.selectedJobShipments.length <= 0) {
      this.boundary = null;
      return;
    }

    const lats = this.selectedJobShipments.filter(s => s.dropoff_address.lat && s.dropoff_address.lng).map(s => s.dropoff_address.lat)
    const lngs = this.selectedJobShipments.filter(s => s.dropoff_address.lat && s.dropoff_address.lng).map(s => s.dropoff_address.lng)

    // check if have selectedShipment
    if (this.selectedShipment) {
      const selectedShipment = this.selectedShipment;

      if (selectedShipment && selectedShipment.dropoff_address.lat && selectedShipment.dropoff_address.lng) {
        this.boundary = [
          [selectedShipment.dropoff_address.lng - 0.02, selectedShipment.dropoff_address.lat - 0.02],
          [selectedShipment.dropoff_address.lng + 0.02, selectedShipment.dropoff_address.lat + 0.02]
        ];
        return;
      }
    }

    if (lats.length === 1 && lngs.length === 1) {
      this.boundary = [
        [lngs[0] - 0.02, lats[0] - 0.02],
        [lngs[0] + 0.02, lats[0] + 0.02]
      ];
      return;
    }

    const minLng = _.min(lngs)
    const maxLng = _.max(lngs)
    const minLat = _.min(lats)
    const maxLat = _.min(lats)

    if (minLat > maxLat - 0.04 && minLng > maxLng - 0.04) {
      this.boundary = [
        [lngs[0] - 0.02, lats[0] - 0.02],
        [lngs[0] + 0.02, lats[0] + 0.02]
      ];
      return;
    }

    this.boundary = [
      [_.min(lngs), _.min(lats)],
      [_.max(lngs), _.max(lats)]
    ];
  }

  @computed
  get total_finalize_job_page() {
    if (!this.totalFinalizeJob) return null;
    return Math.ceil(this.totalFinalizeJob/this.size);
  }

  @computed
  get filteredShipments() {
    if (!this.selectedJob || !this.selectedJobShipments) return null;
    let filteredShipments = this.selectedJobShipments;
    if (this.shipmentFilter) {
      const searchFields = [
        "customer.name",
        "customer.phone_number",
        "customer.email",
        "dropoff_address.street",
        "dropoff_address.city",
        "dropoff_address.state",
        "dropoff_address.zipcode",
        "internal_id",
        "delivery_items",
        "tracking_code",
      ];

      filteredShipments = this.selectedJobShipments.filter(s => searchInObject(s, this.shipmentFilter, "i", searchFields));
    }

    if (!this.okShipment) {
      filteredShipments = filteredShipments.filter(s => (s.status !== 'GEOCODED' || s.duplicate_fields));
    }

    if (!this.errorShipment) {
      filteredShipments = filteredShipments.filter(s => s.status === 'GEOCODED');
    }

    if (!this.duplicatedShipment) {
      filteredShipments = filteredShipments.filter(s => !s.duplicate_fields);
    }

    return filteredShipments;
  }

  @action
  handleResolveDuplicates(jobID, cb) {
    this.api.put(`/jobs/draft/${jobID}/resolve-duplicates`).then(res => {
      if(!res.ok && cb) {
        cb(res);
        return;
      }

      if(res?.data?.shipment_count > 0) {
        this.getShipments(r =>  {
          if(cb) cb(res)
        });
      }
    })
  }
}

export default JobStore;
